import * as React from 'react'

function IconLeaf3(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={43}
      height={44}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.862 34.202l33.22-25.735L3.12 43.827S46.536 43.544 42.58.198C42.594.205-1.792-4.403.861 34.202z"
        fill="#F4BA27"
      />
    </svg>
  )
}

export default IconLeaf3
